<script setup lang="ts">
import UiAction from '@/components/core/UiAction.vue';
import UiIcon from '@/components/core/UiIcon.vue';
import UiTouchButton from '@/components/core/UiTouchButton.vue';
import AppAction from '@/models/core/AppAction';

const props = defineProps<{
  action: AppAction;
}>();
</script>

<template>
  <UiTouchButton :as="UiAction" :action="props.action">
    <slot :icon="action.icon" :label="action.label">
      <UiIcon v-if="action.icon" :path="action.icon" />
    </slot>
  </UiTouchButton>
</template>
